// import { useEffect, useState } from "react";
// import { Form, Button } from "antd";
// import { useDispatch, useSelector } from "react-redux";
// import "./Chart.css";
// import * as _ from "lodash";

// import { SelectOption } from "../../../../../components/common/SelectOption/SelectOption";
// import { InputField } from "../../../../../components/common/InputField/InputField";
// import { updateChart } from "../../../../../redux/editorSlice";

// const Chart = ({ selectedResource, activeChartType }) => {
//   const [values, seValues] = useState({});
//   const [availableYaxisValues, setAvailableYaxisValues] = useState([]);
//   const [availableXaxisValues, setAvailableXaxisValues] = useState([]);

//   const [form] = Form.useForm();
//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (selectedResource.availableFields) {
//       const chartDetails = selectedResource?.charts || {};
//       // form.setFieldsValue(Object.assign({}, {
//       //   chartName: chartDetails?.chartName || null,
//       //   chartType: chartDetails?.chartType || null,
//       //   groupBy: chartDetails?.groupBy?.id,
//       //   fieldName: chartDetails?.fieldName?.id
//       // }));
//       form.setFieldsValue(
//         Object.assign(
//           {},
//           {
//             chartName: chartDetails?.chartName || null,
//             chartType: activeChartType, // driven by tile, not chartDetails
//             groupBy: chartDetails?.groupBy?.id,
//             fieldName: chartDetails?.fieldName?.id,
//           },
//         ),
//       );
//       // seValues(Object.assign({}, values, { chartName: chartDetails?.chartType }))
//       seValues(Object.assign({}, values, { chartName: activeChartType }));

//       let colBuilders = [];

//       if (selectedResource && selectedResource.aggregation && selectedResource.aggregation.row) {
//         let fieldsLength = selectedResource?.availableFields.length;
//         colBuilders = selectedResource.aggregation.row.map((r, i) => {
//           return {
//             checked: true,
//             dataType: "number",
//             fieldName: r.displayName,
//             id: fieldsLength + i,
//             colBuilder: r,
//           };
//         });
//       }

//       setAvailableYaxisValues([
//         ...selectedResource?.availableFields?.filter((field) => field.dataType === "number"),
//         ...colBuilders,
//       ]);
//       setAvailableXaxisValues([...selectedResource?.availableFields, ...colBuilders]);
//     }
//   }, [selectedResource]);

//   // ── Effect 2: runs when chart tile changes (pie → bar → line) ──
//   useEffect(() => {
//     if (!activeChartType) return;

//     form.setFieldsValue({
//       chartType: activeChartType,
//       groupBy: null, // reset fields on type change
//       fieldName: null,
//     });

//     seValues({ chartName: activeChartType }); // triggers Pie vs Bar/Line field switch
//   }, [activeChartType]);

//   const handleOnFinish = (chartDetails) => {
//     const selectedFiled = availableYaxisValues.find((value) => value.id === chartDetails.fieldName);
//     const selectdGroupBy = availableXaxisValues.find((value) => value.id === chartDetails.groupBy);
//     dispatch(
//       updateChart(
//         Object.assign({}, chartDetails, {
//           fieldName: selectedFiled,
//           groupBy: selectdGroupBy,
//           chartName: selectedResource?.source?.widgetName,
//         }),
//       ),
//     );
//   };

//   const handleValueChange = (name, value) => {
//     seValues(Object.assign({}, values, { [name]: value }));
//   };

//   return (
//     <div style={{ overflowY: "auto", height: "30vh" }}>
//       <Form form={form} onFinish={handleOnFinish} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
//         {/* <InputField
//           placeholder={'Chart Name'}
//           name={'chartName'}
//           label={'Chart Name'}
//         /> */}

//         <SelectOption
//           placeholder={"Chart Type"}
//           values={["Bar", "Line", "Pie"]}
//           name={"chartType"}
//           label={"Chart Type"}
//           handleOnSelect={(type) => handleValueChange("chartName", type)}
//         />
//         {values?.chartName === "Pie" ? (
//           <>
//             <SelectOption
//               placeholder={"Field Name"}
//               values={availableYaxisValues}
//               valueName={"id"}
//               labelName={"fieldName"}
//               name={"fieldName"}
//               label={"Field Name"}
//             />
//             <SelectOption
//               placeholder={"Field Name"}
//               values={selectedResource?.availableFields}
//               valueName={"id"}
//               labelName={"fieldName"}
//               name={"groupBy"}
//               label={"Group By"}
//             />
//           </>
//         ) : (
//           <>
//             <SelectOption
//               placeholder={"X Value"}
//               values={availableXaxisValues}
//               valueName={"id"}
//               labelName={"fieldName"}
//               name={"groupBy"}
//               label={"X axis"}
//             />
//             <SelectOption
//               placeholder={"Y Value"}
//               values={availableYaxisValues}
//               valueName={"id"}
//               labelName={"fieldName"}
//               name={"fieldName"}
//               label={"Y axis"}
//             />
//           </>
//         )}

//         <Form.Item>
//           <Button type="primary" htmlType="submit">
//             Submit
//           </Button>
//         </Form.Item>
//       </Form>
//     </div>
//   );
// };

// export default Chart;
import { useEffect, useState } from "react";
import { Form, message } from "antd";
import { useDispatch } from "react-redux";
import TickIcon from "../../../../../assets/icons/tick-mark.svg";
import "./Chart.css";

import { SelectOption } from "../../../../../components/common/SelectOption/SelectOption";
import { updateChart } from "../../../../../redux/editorSlice";

const Chart = ({ selectedResource, activeChartType }) => {
  const [values, seValues] = useState({});
  const [availableYaxisValues, setAvailableYaxisValues] = useState([]);
  const [availableXaxisValues, setAvailableXaxisValues] = useState([]);

  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedResource.availableFields) {
      const chartDetails = selectedResource?.charts || {};

      form.setFieldsValue(
        Object.assign(
          {},
          {
            chartName: chartDetails?.chartName || null,
            chartType: activeChartType,
            groupBy: chartDetails?.groupBy?.id,
            fieldName: chartDetails?.fieldName?.id,
          },
        ),
      );

      seValues(Object.assign({}, values, { chartName: activeChartType }));

      let colBuilders = [];
      if (selectedResource?.aggregation?.row) {
        let fieldsLength = selectedResource?.availableFields.length;
        colBuilders = selectedResource.aggregation.row.map((r, i) => ({
          checked: true,
          dataType: "number",
          fieldName: r.displayName,
          id: fieldsLength + i,
          colBuilder: r,
        }));
      }

      setAvailableYaxisValues([
        ...selectedResource?.availableFields?.filter((f) => f.dataType === "number"),
        ...colBuilders,
      ]);
      setAvailableXaxisValues([...selectedResource?.availableFields, ...colBuilders]);
    }
  }, [selectedResource]);

  useEffect(() => {
    if (!activeChartType) return;
    form.setFieldsValue({ chartType: activeChartType, groupBy: null, fieldName: null });
    seValues({ chartName: activeChartType });
  }, [activeChartType]);

  const handleOnFinish = (chartDetails) => {
    const selectedFiled = availableYaxisValues.find((v) => v.id === chartDetails.fieldName);
    const selectdGroupBy = availableXaxisValues.find((v) => v.id === chartDetails.groupBy);
    /* The form rules cover the usual case, but a saved id can also stop matching if the
       resource's columns changed underneath it. Either way, storing half a config gives
       a chart that plots nothing and an export with no series to write. */
    if (!selectedFiled || !selectdGroupBy) {
      message.warning("Pick both fields before applying the chart");
      return;
    }
    dispatch(
      updateChart(
        Object.assign({}, chartDetails, {
          fieldName: selectedFiled,
          groupBy: selectdGroupBy,
          chartName: selectedResource?.source?.widgetName,
        }),
      ),
    );
  };

  const handleValueChange = (name, value) => {
    seValues(Object.assign({}, values, { [name]: value }));
  };

  const isPie = values?.chartName === "Pie";

  return (
    <div className="chart-config-wrapper">
      {/* ── CHART TYPE BADGE ── */}
      <div className="chart-type-badge">
        <span className="chart-type-badge-label">Chart Type</span>
        <span className="chart-type-badge-value">{activeChartType || "—"}</span>
      </div>

      <Form form={form} onFinish={handleOnFinish} className="chart-config-form">
        {/* hidden field to keep chartType in form state */}
        <Form.Item name="chartType" hidden>
          <input />
        </Form.Item>

        {/* ── FIELDS ── */}
        <div className="chart-fields-section">
          {/* Both fields are required on every chart type. Apply had no validation, so a
              chart could be saved with one axis blank - it then plotted nothing, and its
              CSV export had no series to write and quietly produced no file. */}
          {isPie ? (
            <>
              <div className="chart-field-row">
                <label className="chart-field-label">Field Name</label>
                <div className="chart-field-select">
                  <SelectOption
                    placeholder="Field Name"
                    values={availableYaxisValues}
                    valueName="id"
                    labelName="fieldName"
                    name="fieldName"
                    label=""
                    rules={[{ required: true, message: "Pick the field to plot" }]}
                  />
                </div>
              </div>

              <div className="chart-field-row">
                <label className="chart-field-label">Group By</label>
                <div className="chart-field-select">
                  <SelectOption
                    placeholder="Field Name"
                    values={selectedResource?.availableFields}
                    valueName="id"
                    labelName="fieldName"
                    name="groupBy"
                    label=""
                    rules={[{ required: true, message: "Pick the field to group by" }]}
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="chart-field-row">
                <label className="chart-field-label">X axis</label>
                <div className="chart-field-select">
                  <SelectOption
                    placeholder="X Value"
                    values={availableXaxisValues}
                    valueName="id"
                    labelName="fieldName"
                    name="groupBy"
                    label=""
                    rules={[{ required: true, message: "Pick the X axis field" }]}
                  />
                </div>
              </div>

              <div className="chart-field-row">
                <label className="chart-field-label">Y axis</label>
                <div className="chart-field-select">
                  <SelectOption
                    placeholder="Y Value"
                    values={availableYaxisValues}
                    valueName="id"
                    labelName="fieldName"
                    name="fieldName"
                    label=""
                    rules={[{ required: true, message: "Pick the Y axis field" }]}
                  />
                </div>
              </div>
            </>
          )}
        </div>

        {/* ── ACTIONS ── */}
        <div className="chart-action-row">
          <button type="submit" className="chart-btn-apply">
            <img src={TickIcon} alt="tick-icon" className="chart-btn-icon" />
            Apply
          </button>
          <button
            type="button"
            className="chart-btn-reset"
            onClick={() => {
              form.resetFields(["groupBy", "fieldName"]);
              seValues({ chartName: activeChartType });
            }}
          >
            <span className="chart-btn-icon">↺</span> Reset
          </button>
        </div>
      </Form>
    </div>
  );
};

export default Chart;
